
// src/utils/urlMap.js
export const trToEn = {
    "/": "/en",
    "/hakkimizda": "/en/about-us",
    "/ortaklik-yapisi": "/en/partnership-structure",
    "/yonetim-kurulu": "/en/board-of-directors",
    "/tto": "/en/tto",
    "/girisimcilik": "/en/entrepreneurship",
    "/isbirligi": "/en/collaboration",
    "/kumelenme": "/en/clusters",
    "/medya": "/en/media",
    "/basvuru": "/en/application",
    "/iletisim": "/en/contact-us"
};

export const enToTr = {
    "/en": "/",
    "/en/about-us": "/hakkimizda",
    "/en/partnership-structure": "/ortaklik-yapisi",
    "/en/board-of-directors": "/yonetim-kurulu",
    "/en/tto": "/tto",
    "/en/entrepreneurship": "/girisimcilik",
    "/en/collaboration": "/isbirligi",
    "/en/clusters": "/kumelenme",
    "/en/media": "/medya",
    "/en/application": "/basvuru",
    "/en/contact-us": "/iletisim"
};